export const initialSurvey = {
    title: "Anket başlığı",
    endDate: new Date().toISOString(),
    questions: []
};

export const setSurvey = (survey) => ({
    type: "SET_SURVEY",
    payload: survey
});

export const setSurveyPublished = (published) => ({
    type: "SET_SURVEY_EDITOR_PUBLISHED",
    payload: published
});

export const setSurveyResponse = (response) => ({
    type: "SET_SURVEY_RESPONSE",
    payload: response
});

export const setSurveyResponseEmpty = () => ({
    type: "SET_SURVEY_RESPONSE_EMPTY",
    payload: []
});

export const setSurveyResponseHistory = (response) => ({
    type: "SET_SURVEY_RESPONSE_HISTORY",
    payload: response
});

export const setSurveyEditorOpen = (editorOpen) => ({
    type: "SET_SURVEY_EDITOR_OPEN",
    payload: editorOpen
});

export const setSurveyEditorPosition = (position) => ({
    type: "SET_SURVEY_EDITOR_POSITION",
    payload: position
});

export const setSurveyRejected = (rejected) => ({
    type: "SET_SURVEY_REJECTED",
    payload: rejected
});

export const setSurveyReplied = (replied) => ({
    type: "SET_SURVEY_REPLIED",
    payload: replied
});

export const setSurveyResponseWindow = (window) => ({
    type: "SET_SURVEY_RESPONSE_WINDOW",
    payload: window
});

export const setSurveyCancelled = (survey) => ({
    type: "CANCEL_SURVEY",
    payload: survey
});

export const setSurveyState = (state) => ({
    type: "SET_SURVEY_STATE",
    payload: state
});